import { clientOnlyLazy } from 'components/ClientOnlySuspense/clientOnlyLazy';
import LoadingModal from 'modals/LoadingModal';

export const ConfirmationModalContainerLoadable = clientOnlyLazy({
  loader: () =>
    import(
      /* webpackChunkName: "ConfirmationModalContainer" */
      './ConfirmationModalContainer'
    ),
  loading: LoadingModal,
});
